module.exports = __webpack_public_path__ + "img/ico-ygb.62bf4499.png";